// Hero Title Component
// Main headline for the landing page

export function HeroTitle() {
  return (
    <h1 className="landing-title">Revolt</h1>
  );
}
